import { ListItemIcon, Stack } from "@mui/material";
import { VoiceDescriptionProps } from "shared/models";

export default function VoiceAvatarIcon(props: {
  voiceDescription: VoiceDescriptionProps;
}): JSX.Element {
  const { voiceDescription } = props;

  return (
    <ListItemIcon>
      <Stack
        sx={{
          backgroundColor: "#BDBDBD",
          borderRadius: "64px",
        }}
      >
        <img
          width="35px"
          height="35px"
          src={voiceDescription.voiceIcon}
          srcSet={voiceDescription.voiceIcon}
          id={`voices.name.${voiceDescription.voiceName}`}
          alt={voiceDescription.voiceName}
          loading="lazy"
        />
      </Stack>
    </ListItemIcon>
  );
}
